//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import SubMenuContainer from './Shared/SubMenuContainer.vue'
import SubMenuGroup from './Shared/SubMenuGroup.vue'
// import ProjectItem from './Shared/ProjectItem.vue'
import MenuList from './Shared/MenuList.vue'
import SubMenuBasicItem from './Shared/SubMenuBasicItem.vue'
import SearchInputDark from '~/components/Shared/SearchInputDark.vue'
export default {
  components: {
    SubMenuContainer,
    SubMenuGroup,
    // ProjectItem,
    MenuList,
    SubMenuBasicItem,
    SearchInputDark,
  },
  data() {
    return {
      currentProjectId: null,
      searchQuery: '',
    }
  },
  computed: {
    ...mapState(['myProjects']),
    filteredProjects() {
      if (!this.searchQuery) return this.myProjects
      const query = this.searchQuery.toLowerCase()
      return this.myProjects.filter((project) =>
        project.name.toLowerCase().includes(query)
      )
    },
    inCreationProjects() {
      return this.filteredProjects.filter(
        (project) => project.status === 'DRAFT'
      )
    },
    inProgressProjects() {
      return this.filteredProjects.filter(
        (project) => project.status === 'ACTIVE'
      )
    },
    finalizedProjects() {
      return this.filteredProjects.filter(
        (project) => project.status === 'FINISHED'
      )
    },
    subMenuCurrentProjectId() {
      if (this.currentProjectId) return this.currentProjectId
      const path = this.$nuxt.$route.path
      if (!path.includes('/mis-proyectos/')) return null
      if (!path.includes('/mis-proyectos/nuevo')) {
        return parseInt(path.replace('/mis-proyectos/', '').split('/')[0])
      }
      const { code } = this.$nuxt.$route.query
      if (!code) return null
      const project = this.myProjects.find(
        (project) => project.code === code && project.status === 'DRAFT'
      )
      return project?.id
    },
  },
  methods: {
    handleExpanded(projectId) {
      this.currentProjectId =
        this.subMenuCurrentProjectId === projectId ? null : projectId
    },
    handleClickProject(projectId) {
      this.currentProjectId = projectId
      this.$emit('close-submenu')
      this.$store.commit('closeMenuMobile')
    },
  },
}
